module.exports = __webpack_public_path__ + "img/hilife-logo.6e9a5865.png";